module.exports = __webpack_public_path__ + "images/unboxer-df77eb8746a098c4f8da3e0dc508aa77.png";